import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '@shared/shared.module';
import {ContactActionsComponent} from '@components/administration/organization/configuration/contacts/contact-actions/contact-actions.component';
import {ContactModalComponent} from '@components/administration/organization/configuration/contacts/contact-modal/contact-modal.component';
import {ContactsComponent} from '@components/administration/organization/configuration/contacts/contacts.component';


@NgModule({
  declarations: [
    ContactActionsComponent,
    ContactModalComponent,
    ContactsComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    ContactsComponent
  ]
})
export class ContactsModule {
}
